import { render, staticRenderFns } from "./main_data.vue?vue&type=template&id=48cc7bb0&"
import script from "./main_data.vue?vue&type=script&lang=js&"
export * from "./main_data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports